exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reviewBox {\n    position: absolute;\n    right: 100px;\n    z-index: 1000;\n    border: 2px solid red;\n    border-radius: 10px;\n    box-shadow: 2px 20px 40px 30px #666;\n    padding: 20px;\n    background-color: white;\n    max-width: 900px;\n}\n.option {\n    font-size: 1.1em;\n    font-weight: bold;\n    text-decoration: underline;\n}\n.info {\n    font-weight: lighter;\n}\n", ""]);

// exports
